<template>
    <!-- 日期选择器二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-date-picker align="right"
                      v-model="currentModel"
                      :placeholder="placeholder"
                      :type="dateType"
                      :format="dateFormat"
                      value-format="yyyy-MM-dd"
                      :readonly="isReadonly"
                      :disabled="isDisabled"
                      :editable="isEditable"
                      :clearable="isClearable"
                      :picker-options="{
                        disabledDate: handleDisabledDate
                      }"
                      :style="{ width }">
      </el-date-picker>
    </div>
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";
/** 工具方法 ::: 
 *  @function isHoliday 是否为节假日工具方法
 *  @function isSunday 是否为周日工具方法
 *  @function isWeekend 是否为周六、日工具方法
 */
import { isHoliday, isSunday, isWeekend } from "@/utils/date_utils.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
  methods: {
    /** @name 处理禁用日期
     *  @param {Date} date 当前校验日期
     *  @return {Boolean} {true:禁用，false:非禁用}
     *  @version 2019-09-21
     */
    handleDisabledDate(date) {
      // dateFilter => {"1":"节假日", "2":"周日", "3":"双休"}
      let {dateFilter} = this;
      let dateFilterSet = new Set(dateFilter);
      // 双休
      if (dateFilterSet.has(3) && isWeekend(date)) return true;
      // 周日
      if (dateFilterSet.has(2) && isSunday(date)) return true;
      // 节假日
      if (dateFilterSet.has(1) && isHoliday(date)) return true;
      return false;
    },
  },
}

</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemDatePicker.vue